import { useEffect, useState } from 'react';
import classnames from 'classnames';

const VideoPreview = ({
  file,
  videoRef,
  setBookmarkState = () => null,
  activeBookmark = null,
  setActiveBookmark = () => null,
  setFileInfo = () => null,
  displayBookmarkPanel = () => null,
  noPadding = false,
}) => {
  const [wasPlaying, setWasPlaying] = useState(false);
  const [playing, setPlaying] = useState(false);

  const handleTimeUpdate = (event) => {
    setBookmarkState({
      bookmarkData: {
        time: event.target.currentTime,
      },
    });
  };

  const handleLoading = () => {
    setPlaying(false);
  };

  const handlePlaying = () => {
    setPlaying(true);
  };

  useEffect(() => {
    const spacebarKeyListener = (event) => {
      // Play/Pause on spacebar
      if (event.keyCode === 32) {
        if (videoRef.current.paused) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      }
    };

    document.addEventListener('keydown', spacebarKeyListener);

    return () => {
      document.removeEventListener('keydown', spacebarKeyListener);
    };
  }, [videoRef]);

  useEffect(() => {
    if (videoRef.current && activeBookmark !== null) {
      videoRef.current.currentTime = activeBookmark.bookmarkData.time;

      // Re-set the active bookmark in order to be able to trigger the same
      // bookmark again. This could also be done as the video progresses.
      setActiveBookmark(null);
    }
  }, [videoRef, activeBookmark, setActiveBookmark]);

  useEffect(() => {
    if (videoRef.current) {
      if (displayBookmarkPanel) {
        videoRef.current.pause();
      } else if (wasPlaying) {
        videoRef.current.play();
      }
    }
  }, [displayBookmarkPanel, videoRef, wasPlaying]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('waiting', handleLoading);
      videoRef.current.addEventListener('playing', handlePlaying);

      setBookmarkState({
        bookmarkData: {
          time: 0,
        },
      });
    }
  }, [videoRef, setBookmarkState]);

  const handleLoadedMetadata = () => {
    setFileInfo({
      type: 'video',
      duration: videoRef.current.duration,
    });
  };

  const classes = classnames({
    'media-playing': playing,
    'media-loading': !playing,
    'no-padding': noPadding,
  });

  return (
    <div className={`video-preview-content ${classes}`}>
      <video
        key={file.id}
        controls
        autoPlay
        ref={videoRef}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onPlay={() => setWasPlaying(true)}
        onPause={() => {
          if (!displayBookmarkPanel) {
            setWasPlaying(false);
          }
        }}
        onEnded={() => setWasPlaying(false)}
        controlsList="nodownload noremoteplayback noplaybackrate"
        disablePictureInPicture
      >
        <source
          src={file.sourceUrl}
          type={file.mime && file.mime.includes('quicktime') ? 'video/mp4' : file.mime}
        />
        Sorry, your browser doesn't support embedded videos.
      </video>
    </div>
  );
};

export default VideoPreview;
